import React, { useState, useEffect, useContext } from 'react'
import DailySalesHeader from './DailySalesHeader'
import DailySalesInner from './DailySalesInner'
import DailySalesFooter from './DailySalesFooter'
import { appContext } from '../../../../../../App'
import { getDailySalesReport } from '../../../../ReportsFunctions'

export const dailySalesControllerContext = React.createContext()

function useDailySalesController(props) {
  const app = useContext(appContext)
  const { getClientDateTime } = app
  const [year, setYear] = useState(new Date(getClientDateTime()).getFullYear())
  // Add one to get the correct month number (negating 0 as January)
  const [month, setMonth] = useState(new Date(getClientDateTime()).getMonth() + 1) 
  const [dailySales, setDailySales] = useState(null)
  const [yearString, setYearString] = useState('')

  useEffect(() => {
    const init = async () => {
      setDailySales(await getDailySalesReport(app, year, month))
      setYearString(year.toString())
    }

    if (year.toString().length === 4) init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [month, year])

  return ({
    year: [year, setYear],
    month: [month, setMonth],
    dailySales: [dailySales, setDailySales],
    yearString
  })
}

function DailySalesController(props) {
  const dailySalesController = useDailySalesController(props)

  return (
    <React.Fragment>
      <dailySalesControllerContext.Provider value={dailySalesController}>
        <DailySalesHeader />
        <DailySalesInner />
        <DailySalesFooter />
      </dailySalesControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(DailySalesController)